import { useCallback, useEffect, useState } from 'react'
import { noteTakerStore } from 'shared/stores/noteTakerStore'

export default function useStudentNotesTab({ studentId, isActive }) {
	const [deleteTarget, setDeleteTarget] = useState(null)
	const [isDeleting, setIsDeleting] = useState(false)

	const listState = noteTakerStore.getSessionNotesListState(studentId)

	useEffect(() => {
		if (!studentId || !isActive) return
		noteTakerStore.loadSessionNotesForStudent(studentId).catch(() => {})
	}, [studentId, isActive])

	const handleOpenNote = useCallback(
		note => {
			if (!note?.id) return
			noteTakerStore.openStoredNote(studentId, note.id)
		},
		[studentId],
	)

	const handleRequestDelete = useCallback(note => {
		if (!note?.id) return
		setDeleteTarget(note)
	}, [])

	const handleCancelDelete = useCallback(() => {
		if (isDeleting) return
		setDeleteTarget(null)
	}, [isDeleting])

	const handleConfirmDelete = useCallback(async () => {
		if (!deleteTarget?.id || !studentId || isDeleting) return

		setIsDeleting(true)
		try {
			await noteTakerStore.deleteSessionNoteFromList(studentId, deleteTarget.id)
			setDeleteTarget(null)
		} catch {
			// Error state is stored on the list; keep modal open for retry.
		} finally {
			setIsDeleting(false)
		}
	}, [deleteTarget, studentId, isDeleting])

	const handleStartRecording = useCallback(() => {
		noteTakerStore.startRecordingForStudent(studentId).catch(() => {})
	}, [studentId])

	const handleRetry = useCallback(() => {
		noteTakerStore.loadSessionNotesForStudent(studentId).catch(() => {})
	}, [studentId])

	return {
		listState,
		deleteTarget,
		isDeleting,
		handleOpenNote,
		handleRequestDelete,
		handleCancelDelete,
		handleConfirmDelete,
		handleStartRecording,
		handleRetry,
	}
}
